<script>
import confirmationModal from "../../components/modals/modal-confirmation.vue";
import CreateChecklistItem from "../automation-archive/create-checklist-item";
import modalGatedFeatures from '../modals/modal-non-premium-integration-screen.vue';
import { MODAL_NAMES, PREMIUM_FEATURES_KEYS } from "../../utils/constants";

export default {
  name: "accountChecklists",
  mounted: async function () {
    await this.getAllChecklistProofRequirements();
    await this.loadChecklists();

    let self = this;
    this.$root.$on("check-list-item:saved:success", async function () {
      self.editThis = null;
      await self.loadChecklists();
    });
    this.$root.$on("confirm::delete::proofRequirement", async function () {
      if (self.toDelete.id > 0) {
        await self.$A.ProofChecklistService.DeleteProofChecklist(self.toDelete.id);
        self.toDelete = {
          id: 0,
          name: "",
        };
        await self.loadChecklists();
      }
    });
    this.$root.$on("checklist_item:canceled", function () {
      self.editThis = null;
    });
  },
  data() {
    return {
      checklist: [],
      fields: [
        {
          key: 'checklistinfo',
          sortable: false,
          label: ""
        },
        {
          key: 'edit',
          sortable: false,
          label: "",
          tdClass: "action-cell"
        },
        {
          key: 'menu',
          sortable: false,
          label: "",
          tdClass: "action-cell action-cell-menu"
        },
      ],
      editThis: null,
      duplicateThis: null,
      toDelete: {
        id: 0,
        name: "",
      },
      MODAL_NAMES,
      PREMIUM_FEATURES_KEYS
    };
  },
  components: {
    CreateChecklistItem,
    confirmationModal,
    modalGatedFeatures,
  },
  methods: {
    loadChecklists: async function() {
      let checklist = await this.$A.ProofChecklistService.GetAllProofChecklistsItems();
      if (Array.isArray(checklist)) {
        this.checklist = checklist;
      }
    },
    editChecklist: function (checklistItem) {
      this.editThis = checklistItem;
      this.$root.$emit("edit::checklist::item");
    },
    onRowClicked(item) {
      this.editChecklist(item);
      this.$root.$emit('bv::toggle::collapse', 'create-checklist-sidebar-right');
    },
    deleteItem(pr) {
      this.toDelete = pr;
      this.$bvModal.show("deleteProofRequirement");
    },
    getAllChecklistProofRequirements: async function () {
      this.checklistItems = await $A.ProofChecklistService.GetAllProofChecklistsItems();
    },
    duplicate: async function (id) {
      this.duplicateThis = id;
      await this.$A.ProofChecklistService.DuplicateProofChecklist(id);
      await this.loadChecklists();
    },
    handleCreateChecklist() {
      if (!this.isPaidAccount) {
        this.$bvModal.show(MODAL_NAMES.PREMIUM_CHECKLIST_MODAL);
        return;
      }
      this.editThis = null;
    },
    hasRowMenu(item) {
      const canDuplicate = this.isPaidAccount;
      const canDelete = !item.accountWide;
      return canDuplicate || canDelete;
    },
  },
  watch: {},
  props: {
    isPaidAccount: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<template>
  <div style="background-color: #eef2f5!important"
       class="on-mobile text-dark d-flex justify-content-center flex-md-wrap pb-5 px-3 px-md-0">
    <b-card class="mt-3 p-0 h-75 account-checklist-card">
      <b-card-body>
        <div class="card-toolbar">
          <div class="toolbar-count">
            {{ checklist.length }} {{ checklist.length === 1 ? 'checklist' : 'checklists' }}
          </div>
          <div v-if="isPaidAccount">
            <a v-b-toggle:create-checklist-sidebar-right
               @click="editThis = null"
               class="button button-light button-green checklists-btn mb-0">
              Create Checklist
            </a>
          </div>
          <div v-else>
            <button class="button button-locked-checklist feature-lock-btn" @click="handleCreateChecklist">
              Create Checklist <img src="/img/automation-feature-lock.svg" class="feature-icon"/>
            </button>
          </div>
        </div>
        <b-table
            class="checklist-table mb-0"
            :items="checklist"
            :fields="fields"
            responsive
            hover
            v-show="checklist.length > 0"
            thead-class="d-none"
            tbody-tr-class="checklist-row"
            @row-clicked="onRowClicked"
        >
          <template #cell(checklistinfo)="data">
            <div class="d-flex align-items-center">
              <span class="column-header-text" v-html="data.item.name"></span>
              <span class="default-item ml-2" v-show="data.item.accountWide">Default</span>
            </div>
          </template>
          <template #cell(edit)="data">
            <button
                class="row-edit-btn"
                v-b-toggle.create-checklist-sidebar-right
                @click.stop="editChecklist(data.item)"
            >
              Edit
            </button>
          </template>
          <template #cell(menu)="data">
            <span @click.stop>
            <b-dropdown
                v-if="hasRowMenu(data.item)"
                variant="link"
                toggle-class="row-menu-toggle"
                menu-class="row-menu"
                no-caret
                right
                no-flip
                boundary="viewport"
                offset="4"
            >
              <template #button-content>
                <b-icon-three-dots-vertical />
                <span class="sr-only">More actions</span>
              </template>
              <b-dropdown-item
                  v-if="isPaidAccount"
                  @click="duplicate(data.item.id)"
              >
                Duplicate
              </b-dropdown-item>
              <b-dropdown-item
                  v-if="!data.item.accountWide"
                  @click="deleteItem(data.item)"
              >
                Delete
              </b-dropdown-item>
            </b-dropdown>
            </span>
          </template>
        </b-table>
        <confirmationModal
            ref="confirmPRDeletionModal"
            name="deleteProofRequirement"
            event-to-emit-on-confirmation="confirm::delete::proofRequirement"
            confirm-button-text="Delete Requirement"
            question="Are you sure you would like to delete this proof requirement?"
            :body="
              'This change will only effected new proofs. Existing Proofs will not be effected. </br/> </br/> <b>Deleting Requirement:</b> ' +
              toDelete.name
            "
        />
        <modalGatedFeatures :feature-key="PREMIUM_FEATURES_KEYS.CHECKLIST" :modalId="MODAL_NAMES.PREMIUM_CHECKLIST_MODAL" />
        <create-checklist-item :existing-checklist="editThis"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>
.account-checklist-card {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.account-checklist-card ::v-deep .card-body {
  padding: 0px;
}

.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #E5E7EB;
}

.toolbar-count {
  font-family: 'Open Sans';
  font-size: 13px;
  color: #6B7280;
}

::v-deep .checklist-table table {
  margin-bottom: 0;
}

::v-deep .checklist-table table td {
  padding: 14px 24px !important;
  vertical-align: middle !important;
  border-top: 1px solid #F1F2F4;
  border-bottom: 0;
}

::v-deep .checklist-table tbody tr:first-child td {
  border-top: 0;
}

::v-deep .checklist-table table td.action-cell {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

::v-deep .checklist-table table td.action-cell-menu {
  padding-left: 0 !important;
  padding-right: 16px !important;
}

::v-deep .checklist-row {
  cursor: pointer;
}

::v-deep .checklist-table.table-hover tbody tr:hover,
::v-deep .checklist-table tbody tr:hover {
  background-color: #F9FAFB;
  color: inherit;
}

::v-deep .row-menu-toggle {
  color: #6B7280;
  padding: 4px 6px;
  border-radius: 4px;
}

::v-deep .row-menu-toggle:hover,
::v-deep .row-menu-toggle:focus {
  color: #1B1B1C;
  background-color: #F1F2F4;
  text-decoration: none;
  box-shadow: none;
}

::v-deep .row-menu {
  min-width: 8rem;
  font-size: 14px;
}

.column-header-text {
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 20px;
  color: #1B1B1C;
}

.row-edit-btn {
  background: transparent;
  border: 1px solid #D1D5DB;
  color: #1B1B1C;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 6px;
  line-height: 20px;
}

.row-edit-btn:hover {
  background: #FFFFFF;
  border-color: #B4B9C0;
}

.row-edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
}

.checklists-btn {
  padding: 9px 17px !important;
  font-weight: normal;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
}

.default-item {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  height: 20px;
  background: #EBEBED;
  border-radius: 10px;
  font-family: 'Open Sans';
  font-size: 12px;
  line-height: 16px;
  color: #252526;
}

.button-locked-checklist {
  background: var(--Red-600, #CC333F);
  border-radius: 6px;
  box-shadow: 0px 1px 2px 0px rgba(8, 11, 13, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #ffffff;
  font-weight: normal;
  height: 38px;
}

.feature-icon {
  margin-bottom: 2px;
  margin-left: 4px;
  height: 22px;
}

.feature-lock-btn {
  width: fit-content;
  padding: 9px 17px !important;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .card-toolbar {
    padding: 12px 16px;
  }

  .checklists-btn {
    padding: 8px !important;
    border-radius: 5px;
    font-weight: normal !important;
  }
}
</style>
